<section #card class="rsc" role="status" tabindex="-1" data-testid="run-summary">
  <div class="rsc__icon" [class]="'rsc__icon--' + modifier()">
    <mat-icon aria-hidden="true">{{ icon() }}</mat-icon>
  </div>

  <app-res-pill
    [status]="pillStatus()"
    [label]="abortedExecution() ? ('runSummary.aborted' | translate) : statusLabel()"
  />

  <p class="rsc__passed" data-testid="run-summary-passed">
    <strong>{{ passed() }}/{{ total() }}</strong>
    {{ 'runSummary.stepsPassed' | translate }}
  </p>

  <dl class="rsc__stats">
    <div class="rsc__stat">
      <dt>{{ 'runSummary.duration' | translate }}</dt>
      <dd class="rsc__value" data-testid="run-summary-duration">{{ duration() || '—' }}</dd>
    </div>
    <div class="rsc__stat">
      <dt>{{ 'runSummary.failed' | translate }}</dt>
      <dd class="rsc__value" data-testid="run-summary-failed">{{ failed() }}</dd>
    </div>
    <div class="rsc__stat">
      <dt>{{ 'runSummary.blocked' | translate }}</dt>
      <dd class="rsc__value" data-testid="run-summary-blocked">{{ blocked() }}</dd>
    </div>
    <div class="rsc__stat">
      <dt>{{ 'runSummary.skipped' | translate }}</dt>
      <dd class="rsc__value" data-testid="run-summary-skipped">{{ skipped() }}</dd>
    </div>
  </dl>

  @if (aborted() && abortReason() !== undefined) {
    <p class="rsc__abort-reason" data-testid="run-summary-abort-reason">
      <span class="rsc__abort-reason-label">{{ 'runSummary.abortReason' | translate }}</span>
      @if (abortReason(); as reason) {
        <span class="rsc__abort-reason-text">{{ reason }}</span>
      } @else {
        <span class="rsc__abort-reason-text rsc__abort-reason-text--none">
          {{ 'runSummary.noAbortReason' | translate }}
        </span>
      }
    </p>
  }

  <p class="rsc__frozen" data-testid="run-summary-frozen">
    <mat-icon aria-hidden="true">shield</mat-icon>
    {{ (aborted() ? 'runSummary.abortedFrozen' : 'runSummary.frozen') | translate }}
  </p>

  <div class="rsc__actions">
    @if (resultsAvailable()) {
      <button type="button" class="rsc__results" data-testid="run-summary-results" (click)="showResults.emit()">
        {{ 'runSummary.showResults' | translate }}
      </button>
    }
    <button type="button" class="rsc__leave" data-testid="run-summary-leave" (click)="leave.emit()">
      {{ 'runSummary.backToOverview' | translate }}
    </button>
  </div>
</section>
